const _focus =
  "ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-action-primary-hover focus-visible:ring-offset-2";
const _focusDanger = `${_focus} focus-visible:ring-action-destructive-hover`;

const _disabledPointer =
  "disabled:pointer-events-none disabled:opacity-50 data-[disabled]:pointer-events-none data-[disabled]:opacity-50";
const _disabledCursor = "disabled:cursor-not-allowed disabled:opacity-50";

export { _focus, _focusDanger, _disabledPointer, _disabledCursor };
